<div class="rs-panel-flex">
  <div class="rs-panel-flex-cell rs-bg-c2">
    <form [formGroup]="passwordRecoveryMethodForm" (ngSubmit)="setPasswordRecovery()">
      <div class="row">
        <div class="small-12 columns">
          <label for="channel">
            <span class="rs-label">{{
              'password.recovery.method.no.recovery.select.title' | translate
            }}</span>
            <div class="rs-form-item">
              <div class="rs-pdd">
                <select
                  id="channel"
                  name="channel"
                  formControlName="channel"
                  class="rs-filled"
                  autocompleted=""
                  (change)="onChannelChange($event.target.value)"
                >
                  <option value="sms">
                    {{ 'password.recovery.method.no.recovery.sms.option.title' | translate }}
                  </option>
                  <option value="mail">
                    {{ 'password.recovery.method.no.recovery.mail.option.title' | translate }}
                  </option>
                </select>
                <label class="rs-form-label" for="channel">{{
                  'password.recovery.method.no.recovery.desired.channel' | translate
                }}</label>
              </div>
            </div>
          </label>
        </div>

        <div
          class="small-12 columns"
          *ngIf="passwordRecoveryMethodForm.controls['channel'].value === 'sms'"
        >
          <label for="channel">
            <span class="rs-label">{{
              'password.recovery.method.no.recovery.sms.label.title' | translate
            }}</span>
            <mprd-mobile-number-input
              (mobileNumberInputFormStatusAndValue)="onMobileNumberInputFormStatusAndValue($event)"
            ></mprd-mobile-number-input>
          </label>
        </div>

        <div
          class="small-12 columns"
          *ngIf="passwordRecoveryMethodForm.controls['channel'].value === 'mail'"
        >
          <label for="channel">
            <span class="rs-label">{{
              'password.recovery.method.no.recovery.mail.label.title' | translate
            }}</span>
            <px-email-input
              [selectedEmailValues]="selectedValues"
              (onValidEmail)="onValidEmail($event)"
            ></px-email-input>
          </label>
        </div>
      </div>

      <p class="right rs-margin-right2">
        <span *ngIf="showLoadingSpinner">
          <px-loading-spinner></px-loading-spinner>
        </span>
      </p>
      <button
        type="submit"
        class="rs-btn"
        [disabled]="!passwordRecoveryMethodForm.valid || showLoadingSpinner"
        [ngStyle]="{
          'pointer-events': !passwordRecoveryMethodForm.valid ? 'none' : 'auto',
          cursor: showLoadingSpinner ? 'not-allowed' : 'auto'
        }"
      >
        {{
          (passwordRecoveryMethodForm.controls['channel'].value === 'sms'
            ? 'password.recovery.method.no.recovery.sms.button.title'
            : 'password.recovery.method.no.recovery.mail.button.title'
          ) | translate
        }}
      </button>
    </form>
  </div>
</div>
